import { styled } from "styled-components";

export const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: right;
  font-size: 28px;
  font-weight: 600;
  text-shadow: 2px 2px 5px #828282c1;
  color: #ffffff;
  background-color: #eed61d;
  border-bottom: 5px solid #a7a7a7df;
  border-radius: 10px;
  padding: 10px 15px;
  margin: 15px 5px;
`;

export const HeaderImg = styled.img`
  height: 33px;
`;
